import RegistrationForm from "../components/RegistrationForm"

export default function Registration() {
    return (
        <RegistrationForm/>
    )
}